import { render, staticRenderFns } from "./couponShare.vue?vue&type=template&id=b8064700&"
import script from "./couponShare.vue?vue&type=script&lang=js&"
export * from "./couponShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports